module.exports = __webpack_public_path__ + "img/31.cc2a0d7f.jpg";